import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BanRemove = ({ song_id, removeHandler }) => {
  const handleClick = () => {
    removeHandler({ song_id: song_id });
  };

  return (
    <FontAwesomeIcon
      icon={["fa", "times"]}
      size="lg"
      className="icon-action"
      onClick={handleClick}
    />
  );
};

export default BanRemove;
